import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Box,
  HStack,
  Text
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { UserAccountStatus } from 'models/User/User';

export interface UserAccountStatusDropdownProps {
  value?: UserAccountStatus;
  onChange: (status?: UserAccountStatus) => void;
  size?: string;
  allowEmpty?: boolean;
}

const getStatusColor = (status?: UserAccountStatus): string => {
  if (!status) return 'gray.500';
  switch (status) {
    case UserAccountStatus.CONFIRMED:
      return 'green.500';
    case UserAccountStatus.BLOCKED:
      return 'red.500';
    case UserAccountStatus.PENDING:
      return 'yellow.500';
    default:
      return 'gray.500';
  }
};

const StatusOption = ({ status }: { status?: UserAccountStatus }) => (
  <HStack spacing={2}>
    <Box
      width="8px"
      height="8px"
      borderRadius="full"
      backgroundColor={getStatusColor(status)}
    />
    <Text>{status || 'All Statuses'}</Text>
  </HStack>
);

export default function UserAccountStatusDropdown({
  value,
  onChange,
  size = 'md',
  allowEmpty = true
}: UserAccountStatusDropdownProps) {
  const handleStatusClick = (status?: UserAccountStatus) => {
    onChange(status);
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        size={size}
        textAlign="left"
        width="100%"
      >
        <StatusOption status={value} />
      </MenuButton>
      <MenuList>
        {allowEmpty && (
          <MenuItem onClick={() => handleStatusClick(undefined)}>
            <StatusOption status={undefined} />
          </MenuItem>
        )}
        {Object.values(UserAccountStatus).map(status => (
          <MenuItem key={status} onClick={() => handleStatusClick(status)}>
            <StatusOption status={status} />
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
